module.exports = "/assets/data/54511302e1472a477df56c18f69c1987-G33.data.json";